import * as React from "react";
import { AssetPage } from "./AssetPage";

type Props = {};

const Asset = (props: Props) => {
	return <AssetPage />;
};

export default Asset;
